import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "../../shared/toastr.service";

@Component({
  selector: "app-expired-trial-success",
  templateUrl: "./success.component.html",
  styleUrls: ["./success.component.scss"],
  standalone: false,
})
export class ExpiredTrialSuccessComponent implements OnInit {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.translate
      .get("trial.expired.success.paymentSuccessAlert")
      .subscribe((translation: string) => {
        this.toastr.success(translation);
      });
  }

  backToApp(): void {
    void this.router.navigate(["/"]);
  }
}
